// Members get my_* fields and counts; admins still get the full lists.
export const hasJoinedEvent = (ev, uid) =>
  !!ev?.my_attendance || (ev?.attendees || []).includes(uid);

export const eventAttendeeCount = (ev) =>
  ev?.attendees_count ?? (ev?.attendees?.length || 0);

export const myEventSubmission = (ev, uid) =>
  ev?.my_submission ?? (ev?.completion_submissions || []).find(s => s.user_id === uid);

export const myChallengeParticipation = (ch, uid) =>
  ch?.my_participation ?? (ch?.participants || []).find(p => (typeof p === 'string' ? p : p?.user_id) === uid);

export const challengeParticipantCount = (ch) =>
  ch?.participants_count ?? (ch?.participants?.length || 0);

export const myChallengeSubmission = (ch, uid) =>
  ch?.my_submission ?? (ch?.completion_submissions || []).find(s => s.userId === uid);

// Seats: members get seats_taken/seats_left from the server; admins get raw lists.
export const eventSeatsTaken = (ev) => {
  if (ev?.seats_taken != null) return ev.seats_taken;
  const extra = (ev?.attendance_records || []).reduce((n, r) => n + Math.max(Number(r?.group_size) || 1, 1) - 1, 0);
  return new Set(ev?.attendees || []).size + extra;
};

export const eventSeatsLeft = (ev) => {
  if (ev && 'seats_left' in ev) return ev.seats_left;
  const max = Number(ev?.max_participants);
  return max > 0 ? Math.max(max - eventSeatsTaken(ev), 0) : null;
};

export const isEventFull = (ev) => eventSeatsLeft(ev) === 0;
